import React from 'react';
import DataTable from "react-data-table-component";
import AdditionalInformationRow from "./AdditionalInformationRow";

const AdditionalInformation = (props) => {

    if (props.datatableHack) {
        const columns = [
            {
                selector: row => row.field,
                grow: 1,
            },
            {
                selector: row => row.value,
                grow: 6,
            },
        ];

        const tableTheme = {
            rows: {
                style: {
                    backgroundColor: '#EFF0F3',
                    minHeight: 40,
                }
            }
        }

        const conditionalRowStyles = [
            {
                when: row => props.data.isStriped,
                style: {
                    backgroundColor: '#F5F6F5',
                },
            }
        ];

        return (
            <DataTable
                noHeader
                noTableHead
                columns={columns}
                data={props.data}
                conditionalRowStyles={conditionalRowStyles}
                customStyles={tableTheme}
            />
        )
    } else {
        return (<>
            { Object.keys(props.data)
                .map(key => (
                    <AdditionalInformationRow
                        key={key}
                        label={ props.data[key].field }
                        content={ props.data[key].value }
                    />
                    )
                )}
        </>)
    }
}
export default AdditionalInformation;
